import React, { useState } from "react";
import { Button, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
// import axios from "axios";
import {
  CustomDivider,
  Image,
  LinkedInButton,
  CustomLinkContainer,
} from "./Login.styled";
import linkedInLogo from "../../assets/icons/icon_linkedin.svg";
import PrimaryButton from "../../component/PrimaryButton";
import UnAuthedLayout from "../../component/UnAuthedLayout";
import PrimaryTextField from "../../component/PrimaryTextField";
import PrimaryLink from "../../component/PrimaryLink";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginUser } from "../../redux/thunk/userThunk";
import ConfirmationModal from "../../component/Modal/ConfirmationModal";
import axiosInstance from "../../api/axios";
import { showToaster } from "../../redux/slices/toastSlice";
import { DisplayErrorMessages } from "../../utils/helper";
import { palette } from "../../themes/theme";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isForceLogout, setIsForceLogout] = useState(false);
  const [forceLogoutEmail, setForceLogoutEmail] = useState(false);

  const handleLogin = async (credentials) => {
    setLoading(true);
    // e.preventDefault()
    try {
      await dispatch(
        loginUser({ ...credentials, setIsForceLogout, setForceLogoutEmail })
      ).unwrap();
      navigate("/map");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const forceLogoutRequest = async () => {
    try {
      await axiosInstance.post("auth/logout", {
        isCrimeRisk: true,
        email: forceLogoutEmail,
      });
    } catch (err) {
      const error = DisplayErrorMessages(err);
      dispatch(
        showToaster({
          dialogBgColor: "bg-danger",
          dialogMsg: error ?? "Please contact the admin",
          showDialog: true,
          timer: "5000",
        })
      );
    } finally {
      setIsForceLogout(false);
    }
  };

  const handleClose = () => {
    setIsForceLogout(false);
  };

  // Formik validation and form submission
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      keepMeLoggedin: false,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Password is required"),
    }),
    onSubmit: (values) => {
      handleLogin(values);
    },
  });

  return (
    <UnAuthedLayout showLoader={false}>
      <Typography
        variant="h5"
        gutterBottom
        color={palette.text.dark}
        fontWeight="bolder"
      >
        Welcome Back!
      </Typography>
      <Typography color={palette.text.dark}>
        Please enter your login details
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <PrimaryTextField
          label="Email Address"
          type="email"
          fullWidth
          margin="normal"
          variant="outlined"
          id="email"
          name="email"
          required
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
        <PrimaryTextField
          label="Password"
          type="password"
          fullWidth
          margin="normal"
          variant="outlined"
          id="password"
          name="password"
          required
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
        />
        <CustomLinkContainer>
          <PrimaryLink to="/forgot-password">Forgot Password?</PrimaryLink>
        </CustomLinkContainer>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          type="submit"
          loading={loading}
          loadingPosition="end"
          sx={{ fontWeight: "bold", color: palette.text.white }}
        >
          Log in
        </Button>
      </form>
      <ConfirmationModal
        open={isForceLogout}
        headerTitle="Warning"
        description="User is already logged in some other device/browser. Do you want to logout from other device/browser ?"
        onSave={forceLogoutRequest}
        handleClose={handleClose}
      />
    </UnAuthedLayout>
  );
}

export default Login;
